import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import MainContent from 'components/AboutUs/MainContent';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';
import useIsMobile from 'hooks/useIsMobile';
import { withTranslations } from 'utils/withTranslations';
import { useTranslation } from 'next-i18next';

export default function AboutUsPage() {
  const isMobile = useIsMobile();
  const { t } = useTranslation('common');

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Head>
        <title>About Us - Mind The Graph</title>

        <meta
          key="description"
          name="description"
          content="Learn more about Mind The Graph and our mission. Discover how we leverage innovative technologies to create engaging visual content."
        />

        <meta
          key="og:title"
          name="og:title"
          property="og:title"
          content="About Us - Mind The Graph"
        />

        <meta
          key="og:description"
          name="og:description"
          property="og:description"
          content="Learn more about Mind The Graph and our mission. Discover how we leverage innovative technologies to create engaging visual content."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}

export const getStaticProps = withTranslations(['common']);
